// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ITnu","title":"styles_title__9VuFJ"};